'use strict';

module.exports = {
  __init__: [ 'outline' ],
  outline: [ 'type', require('./Outline') ]
};


// WEBPACK FOOTER //
// ./~/diagram-js/lib/features/outline/index.js